import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useSearchSocialLinksQuery = createQueryHook(
  ShopRendererApiClient.searchPublicSocialNetworks,
  {
    queryKey: ['searchSocialLinks'],
  },
)
